import { render } from "./CalendarDateTitle.vue?vue&type=template&id=b9867b68&scoped=true"
import script from "./CalendarDateTitle.vue?vue&type=script&lang=ts"
export * from "./CalendarDateTitle.vue?vue&type=script&lang=ts"

import "./CalendarDateTitle.vue?vue&type=style&index=0&id=b9867b68&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b9867b68"

export default script